const SITE_NAME = 'CSSBuy Spreadsheet';
const LOGO_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

function getSiteUrl(): string {
  const envUrl = import.meta.env.VITE_SITE_URL as string | undefined;
  const base = envUrl || window.location.origin;
  return base.replace(/\/+$/, '');
}

function toHreflang(lang: string): string {
  if (lang === 'de') return 'de';
  if (lang === 'en') return 'en';
  return 'pt-BR';
}

export interface JsonLdInput {
  type: 'home' | 'article' | 'article-detail';
  title: string;
  description: string;
  path: string;
  lang: string;
  dateModified: string;
  author?: string;
}

export function injectJsonLd(input: JsonLdInput): void {
  const siteUrl = getSiteUrl();
  const url = siteUrl + (input.path === '/' ? '/' : input.path);
  const hreflang = toHreflang(input.lang);

  const organization = {
    '@type': 'Organization',
    name: SITE_NAME,
    url: siteUrl,
    logo: LOGO_URL,
  };

  const website = {
    '@type': 'WebSite',
    name: SITE_NAME,
    url: siteUrl,
    inLanguage: ['pt-BR', 'de', 'en'],
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      logo: LOGO_URL,
    },
  };

  let pageEntity: Record<string, unknown>;
  if (input.type === 'article-detail') {
    pageEntity = {
      '@type': 'Article',
      headline: input.title,
      description: input.description,
      url,
      datePublished: input.dateModified,
      dateModified: input.dateModified,
      inLanguage: hreflang,
      author: {
        '@type': 'Organization',
        name: input.author || SITE_NAME,
      },
      publisher: {
        '@type': 'Organization',
        name: SITE_NAME,
        logo: LOGO_URL,
      },
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': url,
      },
    };
  } else {
    pageEntity = {
      '@type': 'WebPage',
      name: input.title,
      description: input.description,
      url,
      dateModified: input.dateModified,
      inLanguage: hreflang,
    };
  }

  const graph = [organization, website, pageEntity];

  let el = document.getElementById('seo-jsonld') as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = 'seo-jsonld';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': graph });
}